import { render, staticRenderFns } from "./Sys.vue?vue&type=template&id=7cb5f52a&scoped=true&"
import script from "./Sys.vue?vue&type=script&lang=js&"
export * from "./Sys.vue?vue&type=script&lang=js&"
import style0 from "./Sys.vue?vue&type=style&index=0&id=7cb5f52a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb5f52a",
  null
  
)

export default component.exports